<template>
  <div class="calculator-page">
    <calc-seo-intro path="/calculators/corporate-dining" />
    <corporate-roi-calculator :calculatorTitle="'Corporate Dining ROI'" />
  </div>
</template>

<script>
import CorporateRoiCalculator from "../components/CorporateROICalculator.vue";
import CalcSeoIntro from "../components/CalcSeoIntro.vue";

export default {
  name: "CorporateDiningROI",
  components: {
    CorporateRoiCalculator,
    CalcSeoIntro,
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/app.scss';

.calculator-page {
  width: 100%;
  min-height: calc(100vh - 120px);
}
</style>
